import {
  GET_SCHOOL_REPORTS_LIST,
  convertResult,
  convertParams,
} from 'app/common/api/requests/food/schools/reports_list/get'

import {
  DesktopReportInOrgMap,
  DesktopReportsInOrgRequestParams,
} from 'app/common/types/reports/desktop'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

const defaultState: DesktopReportInOrgMap = new Map()

type Op = CommonDataOptions<DesktopReportInOrgMap, DesktopReportsInOrgRequestParams>

export function useDesktopReportsInOrg(options: Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_SCHOOL_REPORTS_LIST,
    error: 'Не удалось получить список отчетов (desktop) для заведения',
    convertions: {
      convertResult,
      convertParams,
    },
    defaultState,
  })

  return res
}
